module.exports = __webpack_public_path__ + "static/media/gcdef_111.ffd679be.ico";